import { IMcsaMapPoint, TMcsaWorldKey } from '../types/mcsa.interface';

export const MCSA_MAP_VIEW_BOX = '0 0 1600 900';

export const MCSA_MAP_START: IMcsaMapPoint = { x: 0.04, y: 0.82 };

export const MCSA_MAP_BASE_PATH = 'M64 738 C 140 700 170 660 240 612 C 320 540 400 430 496 378 C 590 340 660 520 752 558 C 850 600 920 360 1008 342 C 1100 328 1180 520 1264 540 C 1350 555 1410 380 1472 324';

export const MCSA_WORLD_LAYOUT: Record<TMcsaWorldKey, { x: number; y: number; path: string }> = {
    cur: {
        x: 0.15,
        y: 0.68,
        path: 'M64 738 C 140 700 170 660 240 612',
    },
    travel: {
        x: 0.31,
        y: 0.42,
        path: 'M240 612 C 320 540 400 430 496 378',
    },
    shop: {
        x: 0.47,
        y: 0.62,
        path: 'M496 378 C 590 340 660 520 752 558',
    },
    hobby: {
        x: 0.63,
        y: 0.38,
        path: 'M752 558 C 850 600 920 360 1008 342',
    },
    mingle: {
        x: 0.79,
        y: 0.6,
        path: 'M1008 342 C 1100 328 1180 520 1264 540',
    },
    online: {
        x: 0.92,
        y: 0.36,
        path: 'M1264 540 C 1350 555 1410 380 1472 324',
    },
};
